/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_RecordInputs */

const en_portal_view_record = /** @type {(inputs: Portal_View_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New record`)
};

const pl_portal_view_record = /** @type {(inputs: Portal_View_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowy rekord`)
};

/**
* | output |
* | --- |
* | "New record" |
*
* @param {Portal_View_RecordInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_record = /** @type {((inputs?: Portal_View_RecordInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_RecordInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_record(inputs)
	return en_portal_view_record(inputs)
});